import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, createTextVNode as _createTextVNode, Fragment as _Fragment, createBlock as _createBlock, createSlots as _createSlots, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from './images/icon-edit.png'


const _withScopeId = n => (_pushScopeId("data-v-beb75052"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "upgrade-text-box"
}
const _hoisted_2 = {
  key: 1,
  class: "upgrade-text-box"
}
const _hoisted_3 = { key: 0 }
const _hoisted_4 = { key: 1 }
const _hoisted_5 = ["onClick"]
const _hoisted_6 = { class: "add-operat-box" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "upgrade-tips-box" }, [
  /*#__PURE__*/_createTextVNode(" i：修改后的佣金比例仅针对之后升级的佣金发放"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" ii：当对单个商品设置佣金后，默认佣金比例不再生效 ")
], -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "submit-fixed-wrap-placeholder" }, null, -1))
const _hoisted_9 = { class: "submit-fixed-wrap" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ui_title = _resolveComponent("ui-title")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_ui_form_item = _resolveComponent("ui-form-item")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_UpgradeSetting = _resolveComponent("UpgradeSetting")!
  const _component_ui_popover = _resolveComponent("ui-popover")!
  const _component_el_link = _resolveComponent("el-link")!
  const _component_ui_table = _resolveComponent("ui-table")!
  const _component_ui_card = _resolveComponent("ui-card")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_ui_form = _resolveComponent("ui-form")!
  const _component_ui_container = _resolveComponent("ui-container")!
  const _directive_click_outside = _resolveDirective("click-outside")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createBlock(_component_ui_container, { class: "com-wrap-box" }, {
    default: _withCtx(() => [
      _withDirectives((_openBlock(), _createBlock(_component_ui_form, {
        "label-position": "right",
        "label-width": "150px",
        ref: "form"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_ui_card, null, {
            title: _withCtx(() => [
              _createVNode(_component_ui_title, { title: "分销等级方案" })
            ]),
            default: _withCtx(() => [
              _createVNode(_component_ui_table, {
                border: "true",
                data: _ctx.postData.list,
                style: {"width":"660px"}
              }, _createSlots({
                default: _withCtx(() => [
                  _createVNode(_component_el_table_column, {
                    label: "等级名",
                    width: "160"
                  }, {
                    default: _withCtx(({ row }) => [
                      _createVNode(_component_ui_form_item, {
                        style: {"margin":"0"},
                        data: row.name,
                        required: true,
                        showError: false
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_input, {
                            modelValue: row.name,
                            "onUpdate:modelValue": ($event: any) => ((row.name) = $event),
                            placeholder: "请输入等级名"
                          }, null, 8, ["modelValue", "onUpdate:modelValue"])
                        ]),
                        _: 2
                      }, 1032, ["data"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_table_column, { label: "升级条件" }, {
                    default: _withCtx(({ $index, row }) => [
                      ($index == 0)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_1, " 初始等级， 无需设置 "))
                        : (_openBlock(), _createElementBlock("div", _hoisted_2, [
                            _createElementVNode("div", null, [
                              (row.isSelfBuy == 1)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_3, "自购金额满" + _toDisplayString(row.selfBuyAmount) + "元", 1))
                                : _createCommentVNode("", true),
                              (row.isSalesman == 1)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_4, "推广金额满" + _toDisplayString(row.salesmanyAmount) + "元", 1))
                                : _createCommentVNode("", true)
                            ]),
                            _createElementVNode("div", null, [
                              _createVNode(_component_ui_popover, {
                                width: "360",
                                style: {"margin-left":"10px"},
                                trigger: "click",
                                placement: "right"
                              }, {
                                default: _withCtx(({ hideEvent }) => [
                                  _createVNode(_component_UpgradeSetting, {
                                    prevValue: _ctx.postData.list[$index - 1],
                                    modelValue: row,
                                    onConfirm: ($event: any) => (Object.assign(row, $event)),
                                    hideEvent: hideEvent
                                  }, null, 8, ["prevValue", "modelValue", "onConfirm", "hideEvent"])
                                ]),
                                reference: _withCtx(({ showEvent, hideEvent }) => [
                                  _withDirectives(_createElementVNode("img", {
                                    src: _imports_0,
                                    onClick: showEvent
                                  }, null, 8, _hoisted_5), [
                                    [_directive_click_outside, hideEvent]
                                  ])
                                ]),
                                _: 2
                              }, 1024)
                            ])
                          ]))
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_table_column, {
                    label: "佣金比例",
                    width: "160"
                  }, {
                    default: _withCtx(({ row }) => [
                      _createVNode(_component_ui_form_item, {
                        style: {"margin":"0"},
                        data: row.rate,
                        required: true,
                        showError: false
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_input, {
                            modelValue: row.rate,
                            "onUpdate:modelValue": ($event: any) => ((row.rate) = $event)
                          }, {
                            append: _withCtx(() => [
                              _createTextVNode("%")
                            ]),
                            _: 2
                          }, 1032, ["modelValue", "onUpdate:modelValue"])
                        ]),
                        _: 2
                      }, 1032, ["data"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_table_column, {
                    label: "操作",
                    align: "center",
                    width: "100"
                  }, {
                    default: _withCtx(({ $index }) => [
                      ($index == 0)
                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                            _createTextVNode("-")
                          ], 64))
                        : ($index == _ctx.postData.list.length - 1)
                          ? (_openBlock(), _createBlock(_component_el_link, {
                              key: 1,
                              type: "primary",
                              onClick: ($event: any) => (_ctx.removeLevel($index))
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode("删除")
                              ]),
                              _: 2
                            }, 1032, ["onClick"]))
                          : (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                              _createTextVNode("-")
                            ], 64))
                    ]),
                    _: 1
                  })
                ]),
                _: 2
              }, [
                (_ctx.postData.list.length < 10)
                  ? {
                      name: "footer",
                      fn: _withCtx(() => [
                        _createElementVNode("div", _hoisted_6, [
                          _createVNode(_component_el_link, {
                            type: "primary",
                            onClick: _ctx.addLevel
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode("+ 添加等级")
                            ]),
                            _: 1
                          }, 8, ["onClick"]),
                          _createTextVNode(" (" + _toDisplayString(_ctx.postData.list.length) + "/10) ", 1)
                        ])
                      ]),
                      key: "0"
                    }
                  : undefined
              ]), 1032, ["data"]),
              _hoisted_7
            ]),
            _: 1
          }),
          _hoisted_8,
          _createElementVNode("div", _hoisted_9, [
            _withDirectives((_openBlock(), _createBlock(_component_el_button, {
              onClick: _ctx.submit,
              type: "primary"
            }, {
              default: _withCtx(() => [
                _createTextVNode("保存")
              ]),
              _: 1
            }, 8, ["onClick"])), [
              [_directive_loading, _ctx.submitLoading]
            ]),
            _createVNode(_component_el_button, {
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$router.back()))
            }, {
              default: _withCtx(() => [
                _createTextVNode(" 取消")
              ]),
              _: 1
            })
          ])
        ]),
        _: 1
      })), [
        [_directive_loading, _ctx.loading]
      ])
    ]),
    _: 1
  }))
}